import { GUIDELINES_FILTER_DRAFT } from '@/store/actions/guidelines';

export default {
  name: 'navigation-side',
  components: {},
  props: [],
  data() {
    return {
      collapsed: false,
      manuallyCollapsed: false,
      navigationHidden: false,
      navigationHiddenChanged: false,
    }
  },
  computed: {
  },
  mounted() {

  },
  created() {
    window.addEventListener("resize", this.windowResized);
    this.checkNavigationHidden();
  },
  destroyed() {
    window.removeEventListener("resize", this.windowResized);
  },
  methods: {
    showOnlyDrafts() {
      this.$store.dispatch(GUIDELINES_FILTER_DRAFT).then(() => {
        if (this.$route.path == "/guidelines") {
          this.$router.go();
        } else {
          this.$router.push('/guidelines');
        }
      }).catch((error) => {
        this.handleUnauth(error.response.status);
        this.handleForbidden(error.response.status);
      });
    },
    collapseNavigation() {
      this.collapsed = true;
    },
    unCollapseNavigation() {
      this.collapsed = false;
    },
    checkNavigationHidden() {
      const width = window.innerWidth;
      const lastNavigationHidden = this.navigationHidden;
      this.navigationHidden = width < 992;
      this.navigationHiddenChanged = lastNavigationHidden != this.navigationHidden;
    },
    windowResized() {
      this.checkNavigationHidden();
      if (this.navigationHiddenChanged && this.navigationHidden) {
        this.manuallyCollapsed = this.collapsed;
        this.collapsed = false;
      } else if (this.navigationHiddenChanged) {
        this.collapsed = this.manuallyCollapsed;
      }
    }
  }
}
